import React, { Fragment } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import styles from './index.module.scss';

import { useSignedInUser } from 'hooks/auth';
import { useGuideLabel } from 'hooks/guide-label';
import { buildExpertAccountSectionPath, buildUserAccountSectionPath } from 'constants/route-paths';
import { ACCOUNT_TYPES, accountExpertSections, accountGeneralSections } from 'constants/common';
import { siteFromRootSiteSelector } from 'selectors/root-site';

const WarningMessages = () => {
  const { siteSlug } = useParams();
  const { label: guideLabel } = useGuideLabel(siteSlug);

  const {
    pendingApproval,
    isExpert,
    onboarding,
    payable,
    suspendedExpert,
    phoneApproved = true,
    defaultPhoneAvailable = true,
    invalidStripeAccount,
    learnerApproved = true,
    accountType,
  } = useSignedInUser();

  const { siteName } = useSelector(siteFromRootSiteSelector(siteSlug));

  return (
    !isEmpty(siteSlug) &&
    (accountType === ACCOUNT_TYPES.visitor || (
      <Fragment>
        {pendingApproval && (
          <p
            className={styles.warning_message}
          >{`Your application for a ${guideLabel.toLowerCase()} account is pending approval.`}</p>
        )}
        {!defaultPhoneAvailable && (
          <p className={styles.warning_message}>
            Please click &nbsp;
            <Link
              to={buildUserAccountSectionPath(accountGeneralSections.USER_PROFILE.href, siteSlug)}
              className={styles.link_to_setup}
            >
              here
            </Link>
            &nbsp; to set default phone number for {siteName}
          </p>
        )}
        {defaultPhoneAvailable && !phoneApproved && (
          <p className={styles.warning_message}>Your phone number is waiting for approval.</p>
        )}
        {suspendedExpert && (
          <p className={styles.warning_message}>{`Your ${guideLabel.toLowerCase()} account is suspended.`}</p>
        )}
        {isExpert && !onboarding && !payable && (
          <p className={styles.warning_message}>
            Your payout method has not setup yet. Please click &nbsp;
            <Link
              to={buildExpertAccountSectionPath(accountExpertSections.PAYOUT_METHODS.href, siteSlug)}
              className={styles.link_to_setup}
            >
              here
            </Link>
            &nbsp; to update
          </p>
        )}
        {isExpert && invalidStripeAccount && (
          <p className={styles.warning_message}>
            Our apologies. Your Stripe account is using a legacy account type and needs to be setup again to be
            utilized. Please click &nbsp;
            <Link
              to={buildExpertAccountSectionPath(accountExpertSections.PAYOUT_METHODS.href, siteSlug)}
              className={styles.link_to_setup}
            >
              here
            </Link>
            &nbsp; to update
          </p>
        )}
        {!learnerApproved && (
          <p className={styles.warning_message}>
            Your membership is currently pending admin approval. You cannot schedule a schedule until approved.
          </p>
        )}
      </Fragment>
    ))
  );
};

export default WarningMessages;
